<template>
  <div class="Chat">
    <van-nav-bar title="消息" fixed border>
		<template #right>
			<van-popover v-model="show" theme="dark" trigger="click" :offset="[14,0]" placement="bottom-end" @select="selPopover" :actions="actions">
			  <template #reference>
				  <van-icon name="add-o"/>
			  </template>
			</van-popover>
		</template>
    </van-nav-bar>


    <div v-if="sortChatList.length==0" class="txt_center">
    	<div class="empty">
			<span class="msg">暂无消息，到通讯录找人聊聊吧!</span>
			<van-button type="primary" block @click="addFriend()" style="margin-top:50px;">我要邀请</van-button>
		</div>
    </div>
    <van-swipe-cell v-for="(item, index) in sortChatList" v-else :key="index" :id="item.ug_id">
      <!--群聊-->
      <template v-if="item.ug_id">
        <van-swipe-cell>
          <div
            :class="getGroupStick(item.ug_id) == 1 ?'gray':'van-cell-div'"
            @click="groupChatroom(item.ug_id, item.ug_name)"
          >
            <van-image
              class="err-image-header"
              round
              width="45px"
              height="45px"
              :src="attach_url+item.ug_icon"
            ></van-image>
            <span v-for="(it,index) in groupValue" :key="index+'c'" class="tag1">
              <van-tag
                round
                type="danger"
                v-if="it.group_id == item.ug_id && it.unreadNumber != 0"
              >{{it.unreadNumber}}</van-tag>
            </span>
            <div class="cell-group">
              <van-cell
                :title="item.ug_name"
                :value="item.create_time*1000|moment_format('Y-M-D HH:mm:ss')"
              ></van-cell>
              <van-cell class="van-c-t" title-class="van-ellipsis">
                <template slot="title" v-if="item.ug_type == 'text'">
                  <span
                    v-html="item.ug_group_nick?item.ug_group_nick+'：'+ item.gm_content:item.u_nickname?item.u_nickname+'：' + item.gm_content:item.u_login_id+'：' + item.gm_content"
                  ></span>
                </template>
                <template slot="title" v-else-if="item.ug_type == 'notice'">
                  <span>{{item.gm_content}}</span>
                </template>
                <template slot="title" v-else-if="item.ug_type == 'video'">
                  <span>[视频]</span>
                </template>
                <template slot="title" v-else-if="item.ug_type == 'audio'">
                  <span>[语音]</span>
                </template>
                <template slot="title" v-else>
                  <span>{{item.ug_group_nick?item.ug_group_nick+'：'+'[图片]':item.u_nickname?item.u_nickname+'：'+'[图片]':item.u_login_id+'：'+'[图片]'}}</span>
                </template>
                <van-icon
                  v-if="getGroupNoDistrrbing(item.ug_id) == 1"
                  slot="right-icon"
                  name="/static/icon/avoid.png"
                  style="line-height: inherit;"
                  size="20px"
                />
              </van-cell>
            </div>
          </div>
          <template #right>
            <van-button square type="danger" text="删除" @click="del(item.ug_id,'group')" />
          </template>
        </van-swipe-cell>
      </template>
      <!--单聊-->
      <template v-else>
        <van-swipe-cell>
          <div
            :class="gatStick(item.uid) == 1?'gray':'van-cell-div'"
            @click="enterTheChat(item.uid,item.f_name?item.f_name:item.u_nickname?item.u_nickname:item.u_login_id)"
          >
            <van-image
              class="err-image-header"
              round
              width="45px"
              height="45px"
              :src="attach_url+item.u_headportrait"
            />
            <span v-for="(it,index) in chatvalue" :key="index+'a'" class="tag1">
              <van-tag
                round
                type="danger"
                v-if="it.friend_id == item.uid && it.unreadNumber != 0"
              >{{it.unreadNumber}}</van-tag>
            </span>
            <div class="cell-group">
              <van-cell
                :title="item.f_name?item.f_name:item.u_nickname?item.u_nickname:item.u_login_id"
                :value="item.create_time*1000|moment_format('Y-M-D HH:mm:ss')"
              ></van-cell>
              <van-cell class="van-c-t" title-class="van-ellipsis" info="5">
                <template slot="title" v-if="item.m_type == 'text'">
                  <span v-html="item.m_post_messages"></span>
                </template>
                <template slot="title" v-else-if="item.m_type == 'video'">
                  <span>[视频]</span>
                </template>
                <template slot="title" v-else-if="item.m_type == 'audio'">
                  <span>[语音]</span>
                </template>
                <template slot="title" v-else>
                  <span>[图片]</span>
                </template>
                <van-icon
                  v-if="getNoDisturbing(item.uid) == 1"
                  slot="right-icon"
                  name="/static/icon/avoid.png"
                  style="line-height: inherit;"
                  size="20px"
                />
              </van-cell>
            </div>
          </div>
          <template #right>
            <van-button square type="danger" text="删除" @click="del(item.uid,'one')" />
          </template>
        </van-swipe-cell>
      </template>

      <!-- 群聊 -->
    </van-swipe-cell>

    <!-- 声音提醒 -->
    <audio controls="controls" hidden src="./static/mp3/msg.wav" ref="altaudio"></audio>
  </div>
</template>
<script type='text/ecmascript-6'>
import { Popover } from 'vant';
export default {
	name: "Chat",
	components:{
		"van-popover":Popover
	},
	data() {
		return {
			chatvalue: 0,
			groupValue: 0,
			chatList: "",
			sortChatList: [],
			agent: "",
			url: this.Conf.registUrl,
			u_code: "",
			loading: false,
			finished: false,
			show: false,
			userInfo: JSON.parse(localStorage.getItem("userInfo")),
			u_id: localStorage.getItem("u_id"),
			token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
			attach_url: this.Conf.serverPre,
			defaultImg: 'this.src=\\"' + require("../../assets/logo.png") + '\\"',
			ug_id: "",
			msgshowList:JSON.parse(localStorage.getItem("msgshowLists")),
			chkWebsocketTimer:false,
			actions: [
				{ text: '邀请加入', icon: 'invition' },
				{ text: '发起群聊', icon: 'chat' }
			]
		};
	},
	created() {
		
		if (!(this.u_id && this.token)) {
			this.$router.push({
				path: "/login",
			});
		}
		this.getStateConfigs();
		this.chkSocketState();
	  
		this.loadData();
	},
	methods: {
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				if(confs.attach_url){
					this.attach_url = confs.attach_url.values;
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		},
		chkSocketState() {
			if ( this.websocket && this.websocket.ws && this.websocket.ws.readyState == 1 ) {
				// 监听消息回调
				this.websocket.ws.onmessage = this.getMessage;
			}
			this.chkWebsocketTimer && clearTimeout(this.chkWebsocketTimer)
			this.chkWebsocketTimer = setTimeout(() => {
				this.chkSocketState();
			}, 2000);
		},
		loadData() {
			var par = {
				u_id: this.u_id,
				token: this.token,
				num: Math.random(),
			};
			var url = this.Conf.serverUrl + "Messages/getMessagesList";
			// ---------------------------------------------------------------客服账号专用请求接口-----------------------------------------
			if (this.userInfo.u_type == 2) {
				url = this.Conf.serverUrl + "Service/getMessagesList";
			}
			//----------------------------------------------------------------------------------------------------------
			this.$axios
			.post(url, this.$qs.stringify(par))
			.then((response) => {
				this.sortChatList = this.sortByKey(
					response.data.chatroomMsg,
					"sorting"
				);
			})
			.catch((error) => {});
			this.chatvalue = JSON.parse(localStorage.getItem("unread"));
			this.groupValue = JSON.parse(localStorage.getItem("groupUnread"));
		},
		//数组对象排序  array数组  key 数组对象中的key 升序降序修改大于小于号
		sortByKey(array, key) {
			return array.sort(function (a, b) {
				var x = a[key];
				var y = b[key];
				return x > y ? -1 : x < y ? 1 : 0;
			});
		},
		// 群聊免打扰图标
		getGroupNoDistrrbing(ug_id) {
			return localStorage.getItem(ug_id + "groupNoDistrrbing");
		},
		// 单聊免打扰图标
		getNoDisturbing(uid) {
			return localStorage.getItem(uid + "noDisturbing");
		},
		// 群置顶图标
		getGroupStick(ug_id) {
			return localStorage.getItem(ug_id + "groupStick");
		},
		// 单聊置顶图标
		gatStick(uid) {
			return localStorage.getItem(uid + "stick");
		},
		// 监听socket消息回调
		getMessage(msg) {
			//收到服务器任何信息，心跳重置
			var that = this;
			var data = JSON.parse(msg.data);
			if (data && data.m_type == "alert") {
				that.$toast(data.m_post_messages);
				return;
			}
			switch (data.status) {
				case 1:
					that.$dialog
					.alert({
						message: data.message,
					})
					.then(() => {
						that.$router.push({ path: "/login" });
					});
					break;
				case 2:
					// 重新连接socket fd改变，客户端与服务端token相等时，不退出登入
					if (this.token == data.token) {
						return;
					}
					// 用户在别处登录，客服端与服务端token不相等时
					// 客户端token 与 后台token不相等时，退出登入
					window.localStorage.clear();
					that.$dialog
					.alert({
						message: data.message,
					})
					.then(() => {
						window.localStorage.clear();
						that.$router.push({ path: "/login" });
					});
					break;
				case 3:
					that.websocket.recordUnreadChat(data);
					that.chatvalue = JSON.parse(localStorage.getItem("unread"));
					that.groupValue = JSON.parse(localStorage.getItem("groupUnread"));
					that.loadData();
						//播放声音
					if(data.tag == "one"){
						var noDisturbing = localStorage.getItem( data.data.m_from_user_id + "noDisturbing" );

						if (that.u_id != data.data.m_from_user_id && noDisturbing != 1) {
							// console.log("当前chat播放音乐用户id：" + that.u_id);
							that.$refs.altaudio.currentTime = 0; //从头开始播放提示音
							that.$refs.altaudio.play(); //播放
						}
					}else if (data.tag == "group") {
						var groupNoDistrrbing = localStorage.getItem( data.ug_id + "groupNoDistrrbing" );
						if ( that.u_id != data.data[0].gm_from_id && groupNoDistrrbing != 1
						) {
							// console.log("当前chat播放音乐用户id：" + that.u_id);
							that.$refs.altaudio.currentTime = 0; //从头开始播放提示音
							that.$refs.altaudio.play(); //播放
						}
					}
					that.websocket.staticsMsgUnread();
					break;
				case 6:
					that.websocket.recordUnreadShareLike();
					that.circlecountUnread = that.websocket.staticsShareUnread();
					break;
				case 7:
					that.websocket.recordUnreadShareComment(data);
					that.circlecountUnread = that.websocket.staticsShareUnread();
					break;
				case 99:
					that.$toast('你有一条新的'+data.message);
					break;
				default:
					break;
			}
		},
		// 单聊天页面
		enterTheChat(friend_id, friend_name) {
			this.websocket.resetGroupChatUnread(friend_id);
			this.$router.push({
				name: "Chatroom",
				query: {
					friend_id: friend_id,
					friend_name: friend_name,
					bottomstatus:1,
				},
			});
		},
		// 群聊天页面
		groupChatroom(id, ug_name) {
			this.websocket.resetGroupChatUnread(id);
			this.$router.push({
				name: "GroupChatroom",
				query: {
					ug_id: id,
					ug_name: ug_name,
					url: this.Conf.homeUrl,
				},
			});
		},
		// 顶部搜索
		onClickSearch() {
			this.$router.push({
				name: "Search",
				query: {
					actionName: this.Conf.homeUrl,
				},
			});
		},
		selPopover(act,ind){
			if(act.icon=="invition"){
				this.addFriend();
			}else if(act.icon=="chat"){
				this.groupChat();
			}
		},
		// 邀请朋友
		addFriend() {
			// console.log("邀请朋友");
			this.$router.push({
				name: "Code"
			});
		},
		// 发起群聊
		groupChat() {
			this.$router.push({
				name: "AddGroupChat"
			});
		},
		del(id, val) {
			this.$dialog
			.confirm({
				title: "删除消息",
				message: "确认删除该条消息吗？",
			})
			.then(() => {
			  switch (val) {
				case "group":
				  var par = {
					ug_id: id,
					u_id: this.u_id,
					token: this.token,
				  };
				  break;
				case "one":
				  var par = {
					u_id: this.u_id,
					friend_id: id,
					m_id: 1,
					token: this.token,
					num: Math.random(),
				  };
				  break;
			  }
			  var url = this.Conf.serverUrl + "Friends/delMsgList";
			  if (this.userInfo.u_type == 2) {
				url =
				  this.Conf.serverUrl +
				  "Service/delMsgList" +
				  "?num=" +
				  Math.random();
			  }
			  this.$axios
				.post(url, this.$qs.stringify(par))
				.then((response) => {
					this.loadData();
				})
				.catch((error) => {});
			})
			.catch((error) => {});
		}
	},
	beforeDestroy: function () {
		this.chkWebsocketTimer && clearTimeout(this.chkWebsocketTimer)
	}
};
</script>


// WEBPACK FOOTER //
// src/components/Message/Chat.vue